import { KafkaNote } from '@nf/utils-common/constants';
import { useRouter } from '@/navigation';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { CdnImg } from '@/features/cdn-img';
import { useLicSettings } from '@/domains/config/hooks/use-lic-settings';
import { useWcPromotionActivityAssetLocale } from '@/domains/wc-promotion/hooks/use-wc-promotion-support-lang';


const WC2026PromotionBanner = () => {
	const router = useRouter();
	const assetLocale = useWcPromotionActivityAssetLocale();

	const handleWC2026Click = () => {
		setKafkaNormal({
			note: KafkaNote.WcPromotion2026,
			type: 1,
			action: 6
		});
		router.push('/wc-promotion?tab=lottery');
	};
	return (
		<div className="home-activity-banner home-activity-banner--animate" onClick={handleWC2026Click}>
			<CdnImg
				isGalaxyFolder={true}
				src={`/images/banner/home/${assetLocale}/pm_wc2026-1.png`}
			/>
			<CdnImg
				isGalaxyFolder={true}
				src={`/images/banner/home/${assetLocale}/pm_wc2026-2.png`}
			/>
		</div>
	);
}

export const ExclusiveActivityBanner = () => {
	const { enableWcPromotionLobbyBanner } = useLicSettings();

	if (enableWcPromotionLobbyBanner) {
		return <WC2026PromotionBanner />;
	}
	return null;
};